import React, { useState, useEffect, useRef } from "react";
import Message from "../../../../utils/modals/Message";
import Cards from "../../../../dynamic-components/Cards";
import PopupCards from "../../../../dynamic-components/PopupCards";
import CreateRecordModal from "../../../../utils/modals/export-tab/create-record/CreateRecordModal";
import ExportsTable from "./ExportsTable";
import TabNavCards from "../../../../dynamic-components/TabNavCards";
import {
  exportSwitcher_1,
  exportSwitcher_2,
} from "../../../../utils/extra/cards/swichers";
import { getExportCardsSetData } from "../../../../../context/api/cards/export-tab/getExportCardsSetData";
import { getExportTableSetData } from "../../../../../context/api/tables/home/export-tab/getExportTableSetData";
import { getExportPdfApi } from "../../../../../context/api/reports/exports-reports/getExportPdfApi";
import Spinner from "react-bootstrap/Spinner";
import { useCookies } from "react-cookie";
const ExportsTab = ({ lang, data }) => {
  const [cookies] = useCookies();

  const initialMessageRes = {
    success: Boolean,
    message: String,
    isShow: false,
  };
  const initialAddModal = {
    isShow: false,
    action: "",
    rowData: {},
  };

  const fetched = useRef(false);
  const cardAction = useRef();
  const [activeCard, setActiveCard] = useState("totalOutgoing");
  const [messageResponse, setMessageResponse] = useState(initialMessageRes);
  const [cardsData, setCardsData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [tableLoader, setTableLoader] = useState(true);
  const [btnLoader, setBtnLoader] = useState(false);
  // modals
  const [showAddModal, setShowAddModal] = useState(initialAddModal);
  const [refreshData, setRefreshData] = useState(0);

  const fetchOnStart = async () => {
    fetched.current = false;
    const userId = data.id;

    await getExportCardsSetData(
      lang,
      setMessageResponse,
      cookies,
      setCardsData,
      userId
    );
    await getExportTableSetData(
      lang,
      setMessageResponse,
      cookies,
      activeCard,
      setTableData,
      setTableLoader,
      userId
    );
    fetched.current = true;
  };

  useEffect(() => {
    fetchOnStart();
  }, [refreshData]);

  if (!fetched.current) {
    return (
      <div className="page_loader">
        <Spinner animation="border" variant="warning" />
      </div>
    );
  }

  const fetchTableData = async (key) => {
    setTableLoader(() => true);
    if (key) {
      cardAction.current = key;
    }
    const customer_id = data.id;
    await getExportTableSetData(
      lang,
      setMessageResponse,
      cookies,
      cardAction.current,
      setTableData,
      setTableLoader,
      customer_id
    );
  };

  const dataCard1 = cardsData.rightArray;
  const dataCard2 = cardsData.leftArray[activeCard];

  const navCards = {
    fullName: data.fullName,
    code: data.customer_code,
    phoneNumber: data.phoneNumber,
  };

  const getPdf = async () => {
    const userId = data.id;
    setBtnLoader(() => true);
    await getExportPdfApi(cookies, setMessageResponse, setBtnLoader, userId);
  };
  return (
    <>
      <Message
        messageResponse={messageResponse}
        close={() => setMessageResponse(initialMessageRes)}
        lang={lang}
      />

      <CreateRecordModal
        show={showAddModal.isShow}
        onHide={() => {
          setShowAddModal(initialAddModal)
        }}
        lang={lang}
        action={showAddModal.action}
        userId={data.id}
        data={showAddModal.rowData}
        setRefreshData={setRefreshData}
        
      />

      <div className="exports_tab">
        <TabNavCards data={navCards} />
        <PopupCards
          pageClass="exports_tab"
          lang={lang}
          dataCard1={dataCard1}
          dataCard2={dataCard2}
          switcher_1={exportSwitcher_1}
          switcher_2={exportSwitcher_2}
          activeCard={activeCard}
          setActiveCard={setActiveCard}
          fetchTableData={fetchTableData}
        />
        <ExportsTable
          lang={lang}
          loader={tableLoader}
          tableData={tableData.length > 0 ? tableData : ""}
          setShowAddModal={setShowAddModal}
          setRefreshData={setRefreshData}
          btnLoader={btnLoader}
          getPdf={getPdf}
        />
      </div>
    </>
  );
};

export default ExportsTab;
